module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ro-header"
  }, [_c('svg', {
    staticClass: "bottom-svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "100",
      "height": "100",
      "viewBox": "0 0 100 100",
      "preserveAspectRatio": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0v100h100L0 0z"
    }
  })]), _vm._v(" "), (_vm.type === 'image') ? _c('sky-crop', {
    attrs: {
      "mode": "cover",
      "src": _vm.item
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'video') ? _c('div', {
    staticClass: "video-wrap"
  }, [(_vm.fallback && _vm.showFallback) ? _c('sky-crop', {
    staticClass: "fallback",
    attrs: {
      "mode": "cover",
      "src": _vm.fallback
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.showFallback) ? _c('video', {
    ref: "video",
    class: {
      playing: _vm.videoIsPlaying
    },
    attrs: {
      "src": _vm.item,
      "playsinline": "",
      "autoplay": "",
      "muted": "",
      "loop": ""
    },
    on: {
      "canplaythrough": _vm.playVideo,
      "play": _vm.videoPlaying
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(!_vm.isSubPage) ? _c('sky-svg', {
    attrs: {
      "name": "skew-box-front"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSubPage) ? _c('sky-svg', {
    attrs: {
      "name": "skew-box-page"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inner"
  }, [_vm._t("default")], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/fyrstenberg/Documents/Limbo/Roskilde-Handelsskole-Website-2023/frontend/~/vue-loader/lib/template-compiler.js?{"id":"data-v-959b941a"}!./scripts/ro-header/RoHeader.html
// module id = 384
// module chunks = 1